import { createBrowserRouter } from 'react-router'
import { RequireAuth } from '@/features/auth/RequireAuth'
import { OnboardingGate } from '@/features/onboarding/OnboardingGate'
import { AppLayout } from './AppLayout'
import { EntryEditorPage } from '@/pages/EntryEditorPage'
import { HomePage } from '@/pages/HomePage'
import { LoginPage } from '@/pages/LoginPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { PrivacyPage } from '@/pages/PrivacyPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { TermsPage } from '@/pages/TermsPage'
import { WelcomePage } from '@/pages/WelcomePage'

export const routes = [
  { path: '/login', element: <LoginPage /> },
  // 로그인 전에도 닿아야 한다. 로그인 화면이 이 둘을 가리킨다.
  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  {
    element: <RequireAuth />,
    children: [
      // 이 화면은 앱 레이아웃 밖이다. 헤더의 설정 자리가 여기서 할 일이 아니고 폭도 로그인
      // 화면과 같다.
      { path: '/welcome', element: <WelcomePage /> },
      {
        element: <OnboardingGate />,
        children: [
          {
            path: '/',
            element: <AppLayout />,
            children: [
              { index: true, element: <HomePage /> },
              { path: 'entries/new', element: <EntryEditorPage /> },
              { path: 'entries/:entryId', element: <EntryEditorPage /> },
              { path: 'settings', element: <SettingsPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]

export const router = createBrowserRouter(routes)
